import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, Spin, message } from "antd";
import moneyFormat from "../../functions/utils/moneyFormat";

import getMerchantInvoiceDetail from "functions/merchant/getMerchantInvoiceDetail";
import dateFormatShort from "functions/utils/dateFormatShort";
import { CopyFilled, DownloadOutlined } from "@ant-design/icons";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { bg_button } from "constant/css";
const InvoicePreview = ({ open, close, invoiceId }) => {
  const merchantId = localStorage.getItem("merchantId");
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const printRef = useRef();

  useEffect(() => {
    const fetchInvoice = async () => {
      setLoading(true);
      try {
        const response = await getMerchantInvoiceDetail(merchantId, invoiceId);
        if (!response) throw new Error("No response");
        setInvoice(response);
      } catch (error) {
        console.error("Error fetching invoice:", error);
        message.error("Failed to fetch invoice details");
      } finally {
        setLoading(false);
      }
    };
    if (invoiceId) fetchInvoice();
    else close();
  }, [invoiceId]);
  const copyAccount = () => {
    navigator.clipboard.writeText(
      invoice?.bank_account || "MN 43 0005 00 5570025382"
    );
    message.success("Дансны дугаар хуулагдлаа");
  };
  const copyDescription = (e) => {
    const des = `merchant_${merchantId}_
              ${invoice?.id}`;
    navigator.clipboard.writeText(des);
    message.success("Гүйлгээний утга хуулагдлаа");
  };
  const downloadPDF = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`invoice_${invoice?.id}.pdf`);
  };
  return (
    <Modal
      open={open}
      onCancel={close}
      closeIcon={null}
      style={{ top: 20 }}
      footer={
        <Button
          className={`${bg_button}`}
          icon={<DownloadOutlined />}
          type="primary"
          onClick={downloadPDF}
          disabled={loading}
        >
          PDF татах
        </Button>
      }
      width={500}
    >
      <Spin spinning={loading} className="custom-green-spin">
        <div ref={printRef} className="p-6 text-sm text-gray-800 rounded">
          <div className="flex justify-between items-center mb-2">
            <img
              src="/smartbilling.png"
              alt="Company Logo"
              width={80}
              height={80}
              className="rounded-xl"
            />
            <h1 className="text-3xl font-extrabold ">Нэхэмжлэл</h1>
          </div>

          <div className="flex justify-between mb-4">
            <div>
              <h2 className="font-bold text-lg text-black">
                {"Смартбиллинг ХХК"}
              </h2>
              <p>{"contact@smartbilling.mn"}</p>
              <p>
                Утас: <span className="text-xs">+976</span> 7777 5565
              </p>
            </div>
            <div className="flex  flex-col items-end">
              <div className="flex flex-row">
                <h3 className="text-gray-600text-xs   font-semibold">
                  Дугаар:
                </h3>{" "}
                <strong>#{invoice?.id}</strong>
              </div>
              <div className="flex  items-center justify-center flex-row">
                <h3 className="text-gray-600 text-xs font-semibold">Date:</h3>
                {dateFormatShort(invoice?.createdAt)}
              </div>
            </div>
          </div>

          <div className="mb-4">
            <h3 className="text-gray-600 font-semibold">Төлөгч:</h3>
            <p>{invoice?.merchant.name}</p>
            <p>{invoice?.merchant.email}</p>
          </div>

          <table className="w-full text-xs max-w-[860px] mx-auto text-left border border-gray-300 mt-4">
            <thead className="bg-gray-100 text-[10px] text-gray-700">
              <tr>
                <th className="px-3 py-2 border">#</th>
                <th className="px-3 py-2 border">Нэхэмжлэлийн утга</th>
                <th className="px-3 py-2 border text-center">Тоо/ш</th>
                <th className="px-3 py-2 border text-center">Нэгж үнэ</th>
                <th className="px-3 py-2 border text-right">Нийт үнэ</th>
              </tr>
            </thead>
            <tbody>
              {invoice?.merchantInvoiceItems.map((item, idx) => (
                <tr key={idx} className="border-t">
                  <td className="px-3 py-2 border text-center">{idx + 1}</td>
                  <td className="px-3 py-2 border">{item.description}</td>
                  <td className="px-3 py-2 border text-center">
                    {item.quantity}
                  </td>
                  <td className="px-3 py-2 border text-right">
                    {moneyFormat(item.rate)}
                  </td>
                  <td className="px-3 py-2 border text-right">
                    {moneyFormat(item.amount)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="mt-4 flex justify-end text-sm">
            <div className="space-y-1 text-right w-100%">
              <div className="flex justify-between">
                <span className="text-gray-600">Нийлбэр дүн</span>
                <span>{moneyFormat(invoice?.amount)}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">НӨАТ (10%)</span>
                <span>{moneyFormat(invoice?.vatAmount)}</span>
              </div>
              <div className="flex justify-between items-center font-bold text-lg">
                <span>Нийт дүн:</span>
                <span className={`font-bold`}>
                  {moneyFormat(invoice?.total)}
                </span>
              </div>
            </div>
          </div>

          <div className="mt-6 text-sm">
            <p>
              <strong className="text-sm">Үйлчилгээний нөхцөл:</strong>{" "}
              <span className="text-gray-500">
                Төлбөр төлснөөр Билл мэдээлэх үйлчилгээ идэвхжинэ.
              </span>
            </p>
            <p>
              <strong>Банк:</strong>{" "}
              <span className="text-gray-500">
                {invoice?.merchantId === 3
                  ? "Худалдаа хөгжлийн банк"
                  : "Хаан банк"}
              </span>
            </p>

            <p>
              <strong>Дасны дугаар:</strong>{" "}
              <span className="text-gray-500">
                {" "}
                {merchantId == 3
                  ? "MN38 00040 00499556938"
                  : "MN82 000500 5570137879"}
              </span>
              <CopyFilled className="ml-3" onClick={copyAccount} />
            </p>
            <p>
              <strong>Гүйлгээний утга:</strong>
              <span className="text-gray-500">
                {" "}
                merchant_{merchantId}_{invoice?.id}
              </span>
              <CopyFilled className="ml-3" onClick={copyDescription} />
            </p>
          </div>

          <div className="mt-4 border-t pt-2 text-center text-gray-500 text-xs">
            Хэрэв нэхэмжлэлтэи холбоотой асуух зүйл байвал ,
            contact@smartbilling.com холбогдоно уу.
          </div>
        </div>
      </Spin>
    </Modal>
  );
};

export default InvoicePreview;
